import * as React from "react";
import { Typography } from "@mui/material";

export interface IMetaTitleProps {
  text: string;
}

export function MetaTitle(props: IMetaTitleProps) {
  return (
    <Typography
      variant="h5"
      sx={{
        textAlign: "center",
        fontWeight: "bold",
      }}
    >
      {props.text}
    </Typography>
  );
}
